module.exports = "/_next/static/images/8f7efc2020aa0661bdc914a37ef81de8-roxinho-card-with-phone-lg@1x.jpg.webp";